/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 *  @module ckeditor5/utils
 */

export * from '@ckeditor/ckeditor5-utils';
